import React from 'react';
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
const uuid = require('uuid');
const map = require('lodash/map');
const Moment = require('moment');

const LocalAssignmentsStore = require('../../stores/local_assignments_store');
const AssignmentActions = require('../../actions/AssignmentActions');
import TileListEmpty from '../tiles/TileListEmpty';
import SortableTableClassic from '../table/SortableTableClassic';

const propTypes = {
    className: PropTypes.string,
};
const defaultProps = {
    className: '',
};

class LocalAssignmentsStudentView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localAssignmentStoreState: LocalAssignmentsStore.getState(),
        };

        this.assignmentClickHandler = this.assignmentClickHandler.bind(this);
        this.unsubscribes = [
            LocalAssignmentsStore.listen(this.onLocalAssignmentStoreChange.bind(this))
        ];
    }

    UNSAFE_componentWillMount() {
        if (!this.state.localAssignmentStoreState.requested) {
            AssignmentActions.getLocalAssignments(uuid.v4());
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onLocalAssignmentStoreChange(state) {
        this.setState({
            localAssignmentStoreState: state
        });
    }

    assignmentClickHandler(e, hash, something) {
        window.location.href = `/assignment/${hash}/mzl`;
    }

    render() {
        let elems;
        if (this.state.localAssignmentStoreState) {
            if (this.state.localAssignmentStoreState.localStudentAssignments && (this.state.localAssignmentStoreState.localStudentAssignments.length > 0)) {
                var tableColumns = [
                    {displayName: 'Title',          key: 'title',       size: 3, type: 'string' },
                    {displayName: 'Template',       key: 'templateName', size: 3, type: 'string' },
                    {displayName: 'Start Date',     key: 'start_date',  size: 3, type: 'date', sortKey: 'raw_start_date' },
                    {displayName: 'End Date',       key: 'end_date',    size: 3, type: 'date', sortKey: 'raw_end_date' },
                ];

                const tableRows = map(this.state.localAssignmentStoreState.localStudentAssignments, (assignment) => {
                    // var date = new Moment(assignment.create_date);
                    // var dateString = date.format("MMMM D YYYY");

                    return {
                        key: assignment.hash,
                        title: assignment.name,
                        // raw_date: assignment.create_date,
                        raw_start_date: assignment.start_date,
                        raw_end_date: assignment.end_date,
                        // create_date: dateString,
                        start_date: assignment.start_date ? (new Moment(assignment.start_date).format("MMMM D YYYY")) : '',
                        end_date: assignment.end_date ? (new Moment(assignment.end_date).format("MMMM D YYYY")) : '',
                        templateName: assignment.templateName,
                    };
                });
                elems = (
                    <div className="local-assignment-table">
                        <SortableTableClassic key="t-local-assignments"
                            title="Assignments"
                            onRowClick={this.assignmentClickHandler}
                            rows={tableRows}
                            uniqueRowKey="key"
                            columns={tableColumns}
                        />
                    </div>
                );
            }
            else {
                elems = ( <TileListEmpty promptText={this.state.localAssignmentStoreState.loading ? "Loading..." : "No Assignments."} /> );
            }
        }
        else {
            elems = ( <TileListEmpty promptText="Loading..."/> );
        }

        return (
            <div className={this.props.className}>
                {elems}
            </div>
        );
    }
}

LocalAssignmentsStudentView.propTypes = propTypes;
LocalAssignmentsStudentView.defaultProps = defaultProps;

export default withRouter(LocalAssignmentsStudentView);